(() => {
  'use strict';

  const DESKTOP_MIN_WIDTH = 991;
  const HEADER_SELECTOR = '[data-lmu-header]';
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const touchCapable = (navigator.maxTouchPoints || 0) > 0 || window.matchMedia('(pointer: coarse)').matches;

  function install(header) {
    if (!header || header.dataset.lmuMenuControllerV5 === '1') return;
    header.dataset.lmuMenuControllerV5 = '1';

    const menus = Array.from(header.querySelectorAll('details.lmu-mega'));
    const toggle = header.querySelector('[data-lmu-menu-toggle]');
    const mobileNav = header.querySelector('[data-lmu-mobile-nav]');
    const isDesktop = () => window.innerWidth >= DESKTOP_MIN_WIDTH;
    const canHover = () => isDesktop() && hoverQuery.matches && !touchCapable;

    const closeMenu = (menu) => {
      if (!menu) return;
      menu.removeAttribute('open');
      menu.classList.remove('lmu-mega--active', 'lmu-mega--keyboard-open');
    };

    const closeAll = (except = null) => {
      menus.forEach((menu) => { if (menu !== except) closeMenu(menu); });
    };

    const openMenu = (menu) => {
      if (!isDesktop()) return;
      closeAll(menu);
      menu.setAttribute('open', '');
    };

    const hardReset = () => {
      closeAll();
      if (toggle && mobileNav && isDesktop()) {
        toggle.setAttribute('aria-expanded', 'false');
        mobileNav.hidden = true;
      }
    };

    hardReset();

    if (toggle && mobileNav) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        mobileNav.hidden = !open;
      });
    }

    menus.forEach((menu) => {
      const summary = menu.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        if (!isDesktop()) return;
        event.preventDefault();
        if (menu.open) closeMenu(menu);
        else openMenu(menu);
      });

      summary.addEventListener('keydown', (event) => {
        if (!isDesktop() || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        if (menu.open) closeMenu(menu);
        else openMenu(menu);
      });

      menu.addEventListener('pointerenter', (event) => {
        if (canHover() && (!event.pointerType || event.pointerType === 'mouse')) openMenu(menu);
      });

      menu.addEventListener('pointerleave', (event) => {
        if (canHover() && (!event.pointerType || event.pointerType === 'mouse')) closeMenu(menu);
      });

      menu.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => {
          hardReset();
        }, true);
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (!header.contains(event.target)) closeAll();
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    window.addEventListener('scroll', closeAll, { passive: true });
    window.addEventListener('resize', hardReset);
    window.addEventListener('blur', closeAll);
    window.addEventListener('pagehide', closeAll);
    window.addEventListener('beforeunload', closeAll);
    window.addEventListener('pageshow', () => {
      hardReset();
      requestAnimationFrame(hardReset);
      setTimeout(hardReset, 0);
      setTimeout(hardReset, 120);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') hardReset();
    });
  }

  function initialise(root = document) {
    root.querySelectorAll?.(HEADER_SELECTOR).forEach(install);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
